/*
* 公共方法
* */
export const randomStr = (len=16) => {
	let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';    /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
	let maxPos = $chars.length;
	let string = '';
	for (let i = 0; i < len; i++) {
		string += $chars.charAt(Math.floor(Math.random() * maxPos));
	}
	return string;
}

export const chineseNumber = (index) => {
	let str = '一二三四五六七八九十';
	return str[index];
}
export const LogOutSend = ()=>{
	let data = {
		type: 2,
	};
	const mapFrame = this.$refs['mainIframe'];
	 const iframeWin = mapFrame.contentWindow;
	 iframeWin.postMessage(data,'*')
} 